import React, { useState } from 'react';
import { StickyNote, LogIn, Loader2 } from 'lucide-react';
import { api, setToken } from '../api';

export default function Login({ onLogin }) {
  const [empId, setEmpId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!empId.trim() || !password) return setError('Employee ID and password are required');
    setLoading(true);
    setError('');
    try {
      const r = await api.post('/auth/login', { emp_id: empId.trim(), password });
      setToken(r.data.token);
      const me = await api.get('/auth/me');
      onLogin(me.data);
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === 'string' ? d : 'Login failed — please try again');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#FFFDF6] flex items-center justify-center p-6 relative overflow-hidden" data-testid="login-page">
      <span className="absolute top-14 left-[12%] w-24 h-24 bg-pink-200 rounded-lg rotate-[-8deg] sticky-shadow hidden md:block" />
      <span className="absolute bottom-20 right-[14%] w-28 h-28 bg-sky-200 rounded-lg rotate-[6deg] sticky-shadow hidden md:block" />
      <span className="absolute top-[55%] left-[6%] w-16 h-16 bg-emerald-200 rounded-lg rotate-[10deg] sticky-shadow hidden md:block" />
      <form onSubmit={submit} className="relative bg-yellow-100 border-2 border-yellow-300 rounded-2xl sticky-shadow p-8 w-full max-w-sm rotate-[-1deg]" data-testid="login-form">
        <div className="flex items-center gap-2.5 mb-6">
          <div className="w-11 h-11 rounded-lg bg-yellow-300 border-2 border-yellow-400 rotate-[-4deg] flex items-center justify-center">
            <StickyNote size={20} className="text-yellow-900" />
          </div>
          <div>
            <h1 className="font-display font-extrabold text-2xl leading-none text-slate-900">SND CRM</h1>
            <p className="font-hand text-base text-amber-700 leading-none mt-1">sign in to your artboard</p>
          </div>
        </div>
        <label className="block text-[11px] font-bold uppercase tracking-wider text-yellow-800 mb-1">Employee ID</label>
        <input data-testid="login-emp-id" value={empId} onChange={(e) => setEmpId(e.target.value)}
          placeholder="e.g. 000" autoFocus
          className="w-full bg-white/90 border-2 border-yellow-300 rounded-lg px-3 py-2 text-sm font-semibold text-slate-900 focus:outline-none focus:ring-2 focus:ring-amber-500 mb-3" />
        <label className="block text-[11px] font-bold uppercase tracking-wider text-yellow-800 mb-1">Password</label>
        <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          className="w-full bg-white/90 border-2 border-yellow-300 rounded-lg px-3 py-2 text-sm font-semibold text-slate-900 focus:outline-none focus:ring-2 focus:ring-amber-500 mb-4" />
        {error && (
          <p data-testid="login-error" className="bg-red-100 border border-red-300 text-red-700 rounded-lg px-3 py-2 text-xs font-semibold mb-3">{error}</p>
        )}
        <button data-testid="login-submit" type="submit" disabled={loading}
          className="w-full flex items-center justify-center gap-2 bg-slate-900 text-amber-300 rounded-lg px-4 py-2.5 text-sm font-extrabold hover:bg-slate-700 transition-colors disabled:opacity-60">
          {loading ? <Loader2 size={15} className="animate-spin" /> : <LogIn size={15} />} Sign In
        </button>
        <p className="font-hand text-base text-yellow-800/70 text-center mt-4">roles: Admin · Agent · TV — assigned by your admin</p>
      </form>
    </main>
  );
}
